import React, { useState } from "react";
import { Link } from "react-router-dom";
import img from "/assets/img/new_logo.png";
import navLinks from "../constants/navLinks";
import ContactModal from "./ContactModal";

export default function Header() {
  const [contactOpen, setContactOpen] = useState(false);

  // Mobile Menu Toggle
  const toggleMobileMenu = () => {
    document.body.classList.toggle("mobile-nav-active");
  };

  const closeMobileMenu = () => {
    document.body.classList.remove("mobile-nav-active");
  };

  // Dropdown Toggle for Mobile Only
  const toggleDropdown = (index) => {
    if (window.innerWidth >= 1200) return; // desktop hover, no click required
    const el = document.getElementById(`dropdown-${index}`);
    el?.classList.toggle("dropdown-active");
  };

  return (
    <>
      <header
        id="header"
        className="header d-flex align-items-center fixed-top"
      >
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <div className="">
            {/* LOGO */}
            <Link
              to="/"
              className="logo d-flex align-items-center"
              onClick={closeMobileMenu}
            >
              <img src={img} alt="logo" />
            </Link>
          </div>

          <div className="">
            {/* NAVIGATION */}
            <nav id="navmenu" className="navmenu">
              <ul>
                {navLinks.map((item, i) => {
                  if (item.type === "link") {
                    return (
                      <li key={i}>
                        <Link to={item.to} onClick={closeMobileMenu}>
                          {item.label}
                        </Link>
                      </li>
                    );
                  }

                  if (item.type === "dropdown") {
                    return (
                      <li
                        key={i}
                        className={`${
                          item.columns ? "megamenu dropdown" : "dropdown"
                        }`}
                      >
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleDropdown(i);
                          }}
                        >
                          {item.label} <i className="bi bi-chevron-down"></i>
                        </Link>

                        {/* ----- MEGA MENU ----- */}
                        {item.columns && (
                          <ul id={`dropdown-${i}`}>
                            <div
                              className="row g-3 px-3 py-2"
                              style={{ width: "100%" }}
                            >
                              {item.columns.map((col, c) => (
                                <li className="col-lg-3 col-md-6" key={c}>
                                  <Link
                                    to={col.links[0]?.to || "#"}
                                    onClick={closeMobileMenu}
                                  >
                                    <strong className="d-block mb-2">
                                      {col.title}
                                    </strong>
                                  </Link>
                                </li>
                              ))}
                            </div>
                          </ul>
                        )}

                        {/* ----- SIMPLE DROPDOWN ----- */}
                        {item.items && (
                          <ul id={`dropdown-${i}`}>
                            {item.items.map((dd, d) => (
                              <li key={d}>
                                <Link to={dd.to} onClick={closeMobileMenu}>
                                  {dd.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </nav>
          </div>

          <div>
            {/* Mobile Menu Button */}
            <i
              className="mobile-nav-toggle bi bi-list"
              onClick={toggleMobileMenu}
            ></i>

            {/* CONTACT BUTTON */}
            <button
              className="btn-getstarted"
              onClick={() => setContactOpen(true)}
            >
              Get in Touch
            </button>
          </div>
        </div>
      </header>

      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
}
